import React, {Fragment} from "react"

type Props = {
    score: number
}

function PasswordStrengthBar(props: Props) {

    return (
        <Fragment>
            <div className="position-relative">
                <div className="strength-meter mt-2 visible">
                    <div className="strength-meter-fill" data-strength={props.score}></div>
                </div>
            </div>
        </Fragment>
    )
}

export default PasswordStrengthBar


// WEBPACK FOOTER //
// ./src/user/form/PasswordStrengthBar.tsx